import { DorothyUtils } from '@utils/DorothyUtils'
import { UserTypeService } from '@pages/UserTypeSelection/utils/UserTypeService'
import { EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
import { MissingUserTypeException, InvalidStoreIdException } from '@utils/Exceptions/BaseToolCommonExceptions'

const selectedStoreIdKey = 'SELECTED_STORE_ID'

// this store the StoreID selected in the flows where user has an option to select store ID other than configured.(currently Dorothy)

export class StoreIdService {
    private static selectedStoreId: string = undefined

    public static getSelectedStoreId (): string {
        if (this.selectedStoreId === undefined && window.sessionStorage.getItem(selectedStoreIdKey)) {
            this.setSelectedStoreId(window.sessionStorage.getItem(selectedStoreIdKey))
        }
        return this.selectedStoreId
    }

    public static setSelectedStoreId (storeId) {
        const userType = UserTypeService.getUserType()

        if (typeof userType === 'undefined') {
            throw new MissingUserTypeException({ message: 'No user type selected, cannot set store ID' })
        }

        const _primaryStoreId = EnvironmentDetail.getStoreId()
        const _availableStores = this.retrieveDorothyStoreInfo(_primaryStoreId)

        const allowedStores = _availableStores.storeMap[userType]
        const storeIdx = allowedStores.indexOf(storeId)

        if (storeIdx === -1) {
            throw new InvalidStoreIdException({ message: `Invalid store selected: ${storeId} `
                + `Available Store IDs: ${allowedStores.join(', ')}` })
        }

        this.selectedStoreId = storeId
        window.sessionStorage.setItem(selectedStoreIdKey,storeId)
    }

    public static resetStoreIdService () {
        this.selectedStoreId = undefined
        window.sessionStorage.removeItem(selectedStoreIdKey)
    }

    public static getSelectedStoreIdRegion () {
        if (this.selectedStoreId === undefined && window.sessionStorage.getItem(selectedStoreIdKey)) {
            this.setSelectedStoreId(window.sessionStorage.getItem(selectedStoreIdKey))
        }
        const storeInfo = DorothyUtils.getDorothyStoreInfo(this.selectedStoreId)
        if (!storeInfo || !storeInfo.hasOwnProperty('region')) {
            return undefined
        }
        return storeInfo.region
    }

    public static getAvailableStoresForUser () {
        const userType = UserTypeService.getUserType()

        const _primaryStoreId = EnvironmentDetail.getStoreId()
        console.log('ATBase: StoreIdService Primary Store ID: ', _primaryStoreId)

        // { storeMap: map of UserType to StoreId, stores: array of stores }
        const _availableStores = this.retrieveDorothyStoreInfo(_primaryStoreId)
        console.log('ATBase: Available store choices: ', _availableStores)

        if (typeof userType === 'undefined') {
            throw new MissingUserTypeException({ message: 'Cannot retrieve store IDs before user type set' })
        }

        return _availableStores.stores.filter((store) => {
            return _availableStores.storeMap[userType].indexOf(store.storeId) !== -1
        })
    }

    private static retrieveDorothyStoreInfo (primaryStoreId: string) {
        const dorothyStoreInfo = DorothyUtils.getAvailableStores(primaryStoreId).reduce((acc, cur) => {
            for (const acceptedUserType of cur.acceptedUserTypes) {
                if (!acc.storeMap.hasOwnProperty(acceptedUserType)) {
                    acc.storeMap[acceptedUserType] = []
                }

                acc.storeMap[acceptedUserType].push(cur.storeId)
                acc.stores.push(cur)
            }
            return acc
        }, { storeMap: {}, stores: [] })

        dorothyStoreInfo.stores = dorothyStoreInfo.stores.sort().filter((store, n, all) => {
            return n === 0 || all[n] !== all[n - 1]
        })
        return dorothyStoreInfo
    }
}
